export const STORAGE_KEYS = {
  token: "TOKEN",
  tempToken: "TEMP_TOKEN",
  credentials: "CREDENTIALS",
  userData: "USER_DATA",
  fcmToken: "FCM_TOKEN",
  offerData: "OFFER_DATA",
  offerImages: "OFFER_IMAGES",
  bookingFilters: "BOOKING_FILTERS",
  bookingCount: "BOOKING_COUNT",
};
